class customModal extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#customModal-Overlay').addEventListener('click', this.close.bind(this));
    this.setCustomModalAccessibility();
  }

  setCustomModalAccessibility() {
    const modalLink = document.querySelector('#custom-modal-trigger');
    if(modalLink){
      modalLink.setAttribute('role', 'button');
      modalLink.setAttribute('aria-haspopup', 'dialog');
      modalLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.fillModalContent(modalLink);
        setTimeout(() => {
          this.open(modalLink);
        }, 200);
      });
      modalLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.fillModalContent(modalLink);
          setTimeout(() => {
            this.open(modalLink);
          }, 200);
        }
      });
    }
  }

  fillModalContent(triggeredBy){
    if (triggeredBy){
      let modalHeader = document.querySelector(triggeredBy.getAttribute('href')+'-modal_heading');
      if(modalHeader){
        this.querySelector('.modal__heading').innerHTML = modalHeader.innerHTML;
      }
      let modalContent = document.querySelector(triggeredBy.getAttribute('href')+'-modal_content');
      if(modalContent){
        this.querySelector('.modal_content').innerHTML = modalContent.outerHTML;
      }
    }
  }

  open(triggeredBy) {
    if (triggeredBy){
      this.setActiveElement(triggeredBy);
    }

    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('customModal');
        const focusElement = this.querySelector('.modal__inner') || this.querySelector('.modal__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('custom-modal', customModal);
